import { render, staticRenderFns } from "./GlobalRequestStatus.vue?vue&type=template&id=24649d05&scoped=true&"
import script from "./GlobalRequestStatus.vue?vue&type=script&lang=js&"
export * from "./GlobalRequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRequestStatus.vue?vue&type=style&index=0&id=24649d05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24649d05",
  null
  
)

export default component.exports